import React, { ComponentProps, ReactNode } from "react";
import Typography from "@mui/material/Typography";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import LayoutProtectedRoutes from "@/src/containers/Layouts/LayoutProtectedRoutes";
import { FormProvider } from "@/src/provider/Form/FormProvider";

type ProductFeedbackPageProps = {
  children: ReactNode;
  hintText: ReactNode;
} & Pick<ComponentProps<typeof FormProvider>, "initialValues" | "submitAction">;

export default function ProductFeedbackPage({ children, hintText, initialValues, submitAction }: ProductFeedbackPageProps) {
  return (
    <LayoutProtectedRoutes>
      <HintBox headline={"Ihre Rückmeldung wird benötigt"}>
        <Typography>{hintText}</Typography>
      </HintBox>
      <FormProvider initialValues={initialValues} submitAction={submitAction}>
        {children}
      </FormProvider>
    </LayoutProtectedRoutes>
  );
}
